// extracted by mini-css-extract-plugin
export default {"card":"eAkkDFG4jLlon0b77Euk","arrow":"OrAp3lUdpmGaRPb8epPX","logo":"CHuC3MAUY7PNIcVTVcad"};